import type { LocationBrief } from '@/api/types'
import { WIDOCZNE_ODDZIALY } from '@/lib/format'
import { Badge } from './Badge'

/**
 * Plakietki oddziałów — komplet jako jedno słowo, nadmiar jako licznik.
 *
 * Dwa przypadki, oba wzięte z ekranu kont i kadry:
 *
 * * nauczyciel uczący we wszystkich oddziałach dostawał pięć plakietek, choć
 *   niosły jedną informację — teraz czyta się to tak samo jak u właścicielki,
 *   czyli „Wszystkie oddziały”,
 * * przy trzech i więcej oddziałach komplet nazw rozpychał komórkę tabeli.
 *   Zasada jak przy instrumentach: dwie nazwy i licznik reszty, a pełna lista
 *   w podpowiedzi.
 */
export function LocationBadges({
  locations,
  hasAll = false,
  limit = WIDOCZNE_ODDZIALY,
}: {
  locations: LocationBrief[]
  /** Konto obejmuje wszystkie oddziały — wylicza to serwer, nie przeglądarka. */
  hasAll?: boolean
  limit?: number
}) {
  if (hasAll) {
    return <Badge tone="info">Wszystkie oddziały</Badge>
  }

  if (locations.length === 0) {
    return <span className="text-xs text-on-surface-variant">—</span>
  }

  const ukryte = locations.slice(limit)

  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {locations.slice(0, limit).map((location) => (
        <Badge key={location.id} tone="neutral">
          {location.name}
        </Badge>
      ))}
      {ukryte.length > 0 && (
        <span
          // Pełne nazwy w podpowiedzi: licznik mówi „ile”, a kto potrzebuje
          // „które”, dostaje je bez wchodzenia na kartę.
          title={ukryte.map((item) => item.name).join(', ')}
          className="inline-flex items-center whitespace-nowrap rounded-full bg-surface-container px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-on-surface-variant"
        >
          +{ukryte.length}
        </span>
      )}
    </span>
  )
}
